import * as React from 'react';
import { cn } from '../../lib/utils';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        className={cn(
          'flex h-12 w-full rounded-tile border-2.5 border-ink bg-cream px-3.5 py-2 text-base font-medium text-ink placeholder:text-muted-foreground placeholder:font-normal focus-visible:bg-white focus-visible:shadow-hard focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 appearance-none bg-no-repeat pr-10',
          className
        )}
        ref={ref}
        style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='9' viewBox='0 0 14 9'%3E%3Cpath d='M1.5 1.5 7 7l5.5-5.5' fill='none' stroke='%23161512' stroke-width='2.5' stroke-linecap='round'/%3E%3C/svg%3E\")", backgroundPosition: 'right 14px center', ...props.style }}
        {...props}
      >
        {children}
      </select>
    );
  }
);
Select.displayName = 'Select';

export { Select };
